//FOOTER JS
if (!customElements.get('footer-signup')) {
  class FooterSignup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('submit', (e) => {
        e.preventDefault();
        this.phone = this.querySelector('[data-phone-field]')?.value;
        this.smsError = this.querySelector('[data-sms-errors]');
        this.smsSuccessMsg = this.dataset.success;
        this.smsErrorMsg = this.dataset.error;
        this.endpoint =  window.shop.config.api_url;
        this.postForm();
      });
    }

    postForm = async() => {
      const data = new URLSearchParams([
        ['phone', this.phone]
      ]);
      
      await fetch(`${this.endpoint}/attn/subscribe`, {
        method: 'POST',
        body: data
      }).then(res => {
        if (res.ok) {
          this.innerHTML = `<p>${this.smsSuccessMsg}</p>`;
        }
      }).catch((err) => {
        this.smsError = this.smsErrorMsg;
      });
    }

  }
  customElements.define('footer-signup', FooterSignup);
}
